import { connect } from 'react-redux';

import { QuestionBlock } from './QuestionBlock';
import { closeFeedbackPopup, openFeedbackSentPopup, showComplaints } from '../../../../actions/feedback';

import type { DispatchReduxAction } from '../../../../../store';

export const QuestionBlockContainer = connect(undefined, (dispatch: DispatchReduxAction) => ({
  onYesButtonClick() {
    dispatch(closeFeedbackPopup());
    dispatch(openFeedbackSentPopup());
  },
  onNoButtonClick() {
    dispatch(showComplaints());
  },
  onDidNotPickUpPhoneButtonClick() {
    dispatch(closeFeedbackPopup());
    dispatch(openFeedbackSentPopup());
  },
}))(QuestionBlock);
